import {RegulationMenuItemFactoryBase} from "../../menu-items-common/regulations-specific/regulation-menu-item-factory-base";
import {MenuItemKey} from "../../configurations/config-data-sections/generated-config-const";
import {IMenuItemRenderer} from "../../menu-items-common/renderer/menu-item.renderer.interface";
import {ItalyTestMenuItemRenderer} from "./side-menu/italy.test-menu-item.renderer";

/**
 * This class is for demonstrating how to override menu items per regulation. It should be removed when we will have a real case
 */
export class ItalyMenuItemFactory extends RegulationMenuItemFactoryBase {
    getSideMenuItem(key: MenuItemKey): IMenuItemRenderer | null {
        switch (key) {
            case "testRegulationSpecificMenuItem":
                return new ItalyTestMenuItemRenderer(this.services.sideMenu.menuItemConfigReader, this.services);
            default:
                return super.getSideMenuItem(key);
        }

    }
}